<template>
  <div>
    <el-card>
      <div slot="header" class="clearfix">
        <el-col :lg="8">
          {{ $t("cadastro-cliente") }} <small>({{ total }} registros)</small>
        </el-col>
        <el-col :offset="8" :lg="8">
          <el-pagination
            class="right"
            :page-size="filter.records"
            background
            @current-change="fetchRecords"
            @size-change="changeSize"
            :current-page.sync="filter.page"
            layout="sizes, prev, pager, next"
            :page-sizes="[
              50, 100, 150, 200, 250, 300, 350, 400, 450, 500, 1000,
            ]"
            :total="total"
          ></el-pagination>
        </el-col>
      </div>
      <el-row type="flex" justify="end">
        <el-col :xs="24" :sm="12" :md="12" :lg="4" :xl="4">
          <el-select :placeholder="$t('tipo-cliente')" v-model="filter.customerType" @change="fetchRecords">
            <el-option label="Tipo de Cliente (Todos)" value="" />
            <el-option label="Cliente" value="1" />
            <el-option label="Licença" value="2" v-if="userType === '1'" />
            <el-option label="Filial" value="3" />
          </el-select>
        </el-col>
        <el-col :xs="24" :sm="12" :md="12" :lg="6" :xl="6">
          <el-input
            placeholder="Pesquisar por nome, razão social, CPF/CNPJ ou Id Loja"
            prefix-icon="el-icon-search"
            v-model="filter.word"
            v-on:keyup.native.enter="fetchRecords()"
          >
            <el-button slot="append" @click="fetchRecords" icon="el-icon-search"></el-button>
          </el-input>
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3">
          <el-button
            class="right"
            type="primary"
            icon="el-icon-plus"
            @click="add()"
            >{{ $t("adicionar") }}</el-button
          >
        </el-col>
        <el-col :xs="12" :sm="6" :md="6" :lg="3" :xl="3" v-if="userType === '1'">
          <el-button
            class="right"
            type="info"
            icon="el-icon-connection"
            @click="transfer()"
            >{{ $t("transferir") }}</el-button
          >
        </el-col>
      </el-row>
      <el-table
        :data="tableData"
        stripe
        style="width: 100%"
        :default-sort="{ prop: 'name', order: 'ascending' }"
      >
        <el-table-column
          sortable
          width="100"
          prop="externalId"
          label="Id Loja"
        ></el-table-column>
        <el-table-column
          sortable
          width="140"
          prop="customerType"
          :label="$t('tipo-cliente')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="name"
          :label="$t('nome-fantasia')"
        ></el-table-column>
        <el-table-column
          sortable
          prop="companyname"
          :label="$t('razao-social')"
        ></el-table-column>
        <el-table-column
          prop="federalid"
          width="140"
          :label="$t('cpf-cnpj')"
        ></el-table-column>
        <el-table-column label="#" width="120">
          <template slot-scope="scope">
            <el-button
              type="info"
              icon="el-icon-edit"
              @click="editar(scope.row.id)"
              circle
            ></el-button>
            <el-button
              type="danger"
              icon="el-icon-delete"
              @click="remove(scope.row.id, scope.row.name)"
              circle
            ></el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="bottom clearfix">
        <el-row :gutter="5">
          <el-col :lg="8">
            <el-pagination
              :page-size="filter.records"
              background
              @current-change="fetchRecords"
              :current-page.sync="filter.page"
              layout="prev, pager, next"
              :total="total"
              v-show="total > filter.records"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import { i18n } from "@/plugin/i18n";
import { CustomerService } from "@/services/customers/customers.services";
import { UserService } from "@/services/users/user.services";

export default {
  name: "Customer",
  methods: {
    fetchRecords() {
      const vm = this;
      const loading = vm.$loading(vm.$options.loading);
      CustomerService.list(vm.filter.records, vm.filter.page, vm.filter.customerType, vm.filter.word)
        .then((response) => {
          vm.tableData = response.records;
          vm.total = response.total;
        })
        .catch((error) => {
          vm.$notify.error({
            title: i18n.tc("erro"),
            message: error,
          });
        })
        .finally(() => loading.close());
    },
    add() {
      var vm = this;
      vm.$router.replace({ name: "customer.add" });
    },
    editar: function (id) {
      this.$router.replace({
        name: "customer.edit",
        params: { id: id },
      });
    },
    transfer: function (id) {
      this.$router.replace({ name: "customer.transfer" });
    },
    remove: function (id, name) {
      const vm = this;
      this.$confirm(
        i18n.t("confirmar-eliminacao-cliente", { customer: name }),
        i18n.tc("aviso"),
        {
          confirmButtonText: "OK",
          cancelButtonText: i18n.tc("cancelar"),
          type: i18n.tc("aviso"),
          center: true,
        }
      ).then(() => {
        const loading = vm.$loading(vm.$options.loading);
        CustomerService.delete(id)
          .then((response) => {
            setTimeout(() => {
              vm.fetchRecords();
            }, 300);
            this.$message({
              type: "success",
              message: i18n.tc("cliente-eliminado-sucesso"),
            });
          })
          .catch((error) => {
            vm.$message({
              type: "error",
              message: error,
            });
          })
          .finally(() => loading.close());
      });
    },
    changeSize(size) {
      const vm = this;
      vm.filter.records = size;
      vm.fetchRecords();
    },
  },
  mounted() {
    const vm = this;
    UserService.me()
      .then((response) => {
        vm.userType = response.type;
        vm.fetchRecords();
      })
      .catch((error) => {
        vm.$message({
          type: "error",
          message: error,
        });
      });
  },
  data() {
    return {
      userType: '2',
      filter: {
        records: 50,
        page: 1,
        word: "",
        customerType: '',
      },
      tableData: [],
      total: 0,
    };
  },
};
</script>
<style>
.right {
  float: right;
}
</style>